/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_DescriptionInputs */

const en_auth_signup_description = /** @type {(inputs: Auth_Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It takes a minute. Then you set your hours and start taking bookings.`)
};

const pl_auth_signup_description = /** @type {(inputs: Auth_Signup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajmie minutę. Potem ustawiasz godziny i przyjmujesz pierwsze rezerwacje.`)
};

/**
* | output |
* | --- |
* | "It takes a minute. Then you set your hours and start taking bookings." |
*
* @param {Auth_Signup_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_description = /** @type {((inputs?: Auth_Signup_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_description(inputs)
	return en_auth_signup_description(inputs)
});